import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function TelegramIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M17.7231 7.80289C17.688 8.28913 17.4101 9.98785 17.1331 11.8272L16.2658 17.2718C16.2658 17.2718 16.1971 18.0691 15.6072 18.2078C15.0168 18.347 14.0463 17.723 13.873 17.5838C13.7343 17.4802 11.2719 15.9192 10.3699 15.156C10.1271 14.9482 9.8501 14.532 10.405 14.0462C11.653 12.9019 13.1448 11.4802 14.0463 10.5782C14.4619 10.1621 14.8791 9.19105 13.1448 10.3699L8.2541 13.6651C8.2541 13.6651 7.69922 14.0122 6.65906 13.6992C5.61794 13.3872 4.40498 12.971 4.40498 12.971C4.40498 12.971 3.57218 12.4512 4.99394 11.8958L13.0752 8.56609C13.873 8.22001 16.5783 7.10977 16.5783 7.10977C16.5783 7.10977 17.8272 6.62401 17.7231 7.80289Z" fill="currentColor"/>
    </SvgIcon>
  );
}
